import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function DeleteSweepIcon(props: IconProps) {
    return <Icon {...props} iconKey={"delete_sweep"}/>
}
